import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { getUser } from '../../reducers/auth';
import UserService from '../../services/user.service';
import OrderService from "../../services/order.service";
import { useForm } from "react-hook-form";
import NewHireKitItem from "../admin/NewHireKitItem";

const ConfirmNewHireKitModal = ({ show, close, confirm, items, address }) => {

    return (
        <Modal dialogClassName="modal-70w" show={show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm New Hire Kit<br /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h4>Delivering to {address.name}</h4>
                    <p style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>{address.street1}<br />
                        {address.street2 != null && address.street2 != "" && <>{address.street2}<br /></>}
                        {address.city}, {address.state} {address.zip}<br />
                    </p>
                    <ul>
                        {items.map(item => (
                            <NewHireKitItem item={item.item} inventory={null} setSize={null} remove={null} edit={false} currentSize={item.selectedSize} />
                        ))}
                    </ul>
                </div>
                <Button onClick={close} variant="secondary" style={{ marginTop: 20, marginRight: 20 }}>
                    Edit Order
                </Button>
                <Button onClick={confirm} variant="success" style={{ marginTop: 20 }}>
                    Confirm Order
                </Button>

            </Modal.Body>
        </Modal >
    );
};

export default ConfirmNewHireKitModal; 